export enum ETagValue {
  NPC = '<NPC>',
  USER = '<USER>',
}

export const TAGS = [{ value: ETagValue.USER }, { value: ETagValue.NPC }];

export const TAG_REG = new RegExp(`(${ETagValue.NPC}|${ETagValue.USER})`);

export const ALWAYS_ALLOW_KEYS = [
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
];

export const CHINESE_REG = /[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/;
